import {
  CoralogixBrowserSdkConfig,
  CoralogixEventType,
  CoralogixLogSeverity,
  CoralogixRum,
} from "@coralogix/browser";
import { ConfigJson } from "./config-json.ts";
import { log } from "./utilities/logger.ts";

export let coralogix: typeof CoralogixRum | undefined;

export default function initCoralogixRum(
  c: ConfigJson,
): typeof CoralogixRum | undefined {
  if (
    !!c.CORALOGIX_API_KEY &&
    !!c.CORALOGIX_APPLICATION_ID &&
    !!c.CORALOGIX_DOMAIN
  ) {
    try {
      const config: CoralogixBrowserSdkConfig = {
        public_key: c.CORALOGIX_API_KEY,
        application: c.CORALOGIX_APPLICATION_ID,
        coralogixDomain: c.CORALOGIX_DOMAIN,
        version: import.meta.env.VITE_APP_VERSION,
        sessionRecordingConfig: {
          enable: true,
          autoStartSessionRecording: true,
          recordConsoleEvents: true,
          maskAllInputs: c.CORALOGIX_MASK_INPUT || true,
        },
        sessionConfig: {
          sessionSampleRate: c.CORALOGIX_SESSION_SAMPLING_RATE || 50,
          alwaysTrackSessionsWithErrors: true,
        },
        debug: false,
        maskInputTypes: c.CORALOGIX_MASK_INPUT
          ? ["password", "email", "number", "date", "text", "tel", "file"]
          : ["password"],
        beforeSend: (event) => {
          if (
            event?.event_context.type === CoralogixEventType.NETWORK_REQUEST
          ) {
            const status = event?.network_request_context?.status_code;
            const requestUrl = event?.network_request_context?.url;
            if (
              status === 403 &&
              requestUrl &&
              requestUrl.endsWith("/api/session")
            ) {
              event.event_context.severity = CoralogixLogSeverity.Warn;
            }
          }

          if (
            event?.event_context.source === "console" &&
            event?.error_context?.error_message?.endsWith("403")
          ) {
            event.event_context.severity = CoralogixLogSeverity.Warn;
          }

          return event;
        },
        networkExtraConfig: [
          {
            url: new RegExp("^(?!\\/?api).+$"), // Capture requests only from backend
            collectReqPayload: true, // Collect request payload
            collectResPayload: true, // Collect response payload
          },
        ],
        ignoreUrls: [
          // ignore urls not related to functionalities
          new RegExp(
            "google\\.com\\/.*(collect|pagead)|analytics\\.google\\.com",
          ),
          new RegExp("cookiebot\\.com"),
          new RegExp("hub(api|spot)\\.com\\/.*(events|pixels|livechat|cta)"),
          new RegExp("clarity\\.ms\\/collect"),
          new RegExp("hotjar\\.io"),
          new RegExp("px\\.ads\\.linkedin\\.com"),
        ],
      };

      CoralogixRum.init(config);

      return coralogix;
    } catch (error) {
      // Ignore errors thrown during Coralogix RUM web client initialization
      log("Error during Coralogix initialization");
    }
  }
}
